import { Check } from "lucide-react";
import { fmtDate, pick } from "@/i18n";
import "./growth-club.css";

const COPY = {
  en: {
    planEyebrow: "Current entitlement",
    noPlanNext: "Choose a one-time package, or request a separate price for monthly support.",
    packageNote: "This is a one-time package. It does not activate monthly support.",
    monthlyNote: "This is a monthly subscription, separate from a one-time package.",
    owned: (name) => `${name} is already active. You do not need to purchase it again.`,
    billing: "Billing",
    amount: "Amount",
    method: "Payment method",
    expiry: "Expiration",
    expiryMissing: "Valid date unavailable; review required",
    billingMissing: "Billing type unavailable",
    methodMissing: "Not recorded",
    oneTime: "One-time package",
    monthly: "Monthly subscription",
    catalogNote: "These are one-time package prices. A package purchase does not activate monthly support. Monthly support has no fixed price here and is quoted separately.",
    currentPackage: "Current package",
    packagesTitle: "One-time packages",
    quoteTitle: "Quote",
    orderRegistered: "Order created",
    awaitingHeading: "Send your receipt only in the NOORIN bot",
    awaitingReceipt: "Order created. After payment, send the receipt image or PDF only in the NOORIN bot.",
    pending: "Receipt received. Payment verification is in progress and this purchase is not active yet.",
    approving: "The founder is verifying this payment now.",
    paidActive: "This order has been paid and its entitlement is active.",
    rejected: "This order was rejected. You can create a new order if you still want this quote.",
    expired: "Quote expired; request a new review.",
    legacy: "Legacy request; new review required",
    destination: "Destination account",
    referenceAccount: "Account used for this order",
    holder: "Account holder",
    openBot: "Open the NOORIN bot to send your receipt.",
    sendReceipt: "Send receipt in the NOORIN bot",
    createOrder: "Create order and send receipt in bot",
    preparing: "Manual payment is being prepared.",
    amountDue: "Amount due",
    ordersTitle: "Order history",
    older: (count) => `Older orders (${count})`,
    packageKind: "One-time package",
    monthlyKind: "Separate monthly subscription",
    upgradeKind: "Package upgrade",
    scope: "Scope",
    validUntil: "Quote valid until",
    credit: "Verified prior-payment credit",
    reviewAmount: "Waiting for the NOORIN team's price proposal",
    quoteIntro: "The NOORIN team reviews the scope. Monthly support has no fixed price and is proposed from scale, revenue, complexity, scope, and workload.",
    awaitingTeam: "Waiting for the NOORIN team's approval. No payment is taken before that.",
    approvedByTeam: "The NOORIN team has approved the scope and price.",
    quoteRecorded: "Your request has been recorded for the NOORIN team.",
    manualTitle: "Manual bank transfer",
    orderCode: "Order code",
    protection: "Your package or subscription starts only after the founder verifies the real bank credit. A receipt alone is not payment confirmation.",
  },
  fa: {
    planEyebrow: "دسترسی فعلی",
    noPlanNext: "یک پکیج یک‌باره انتخاب کنید، یا قیمت اشتراک ماهانه را جداگانه بخواهید.",
    packageNote: "این دسترسی پکیج یک‌باره است و اشتراک ماهانه را فعال نمی‌کند.",
    monthlyNote: "این اشتراک ماهانه است و جدا از پکیج یک‌باره محاسبه می‌شود.",
    owned: (name) => `پکیج ${name} فعال است. خرید دوباره لازم نیست.`,
    billing: "نوع صورتحساب",
    amount: "مبلغ",
    method: "روش پرداخت",
    expiry: "پایان اعتبار",
    expiryMissing: "تاریخ معتبر ثبت نشده؛ نیازمند بررسی",
    billingMissing: "نوع صورتحساب ثبت نشده",
    methodMissing: "ثبت نشده",
    oneTime: "پکیج یک‌باره",
    monthly: "اشتراک ماهانه",
    catalogNote: "این مبالغ قیمت پکیج یک‌باره است. خرید پکیج، اشتراک ماهانه را فعال نمی‌کند. اشتراک ماهانه اینجا قیمت ثابت ندارد و جداگانه پیشنهاد می‌شود.",
    currentPackage: "پکیج فعلی شما",
    packagesTitle: "پکیج‌های یک‌باره",
    quoteTitle: "پیشنهاد قیمت",
    orderRegistered: "سفارش ثبت شده",
    awaitingHeading: "فیش را فقط در بات نورین ارسال کنید",
    awaitingReceipt: "سفارش ثبت شده است. پس از واریز، تصویر یا PDF رسید را فقط در بات نورین ارسال کنید.",
    pending: "رسید دریافت شده و تأیید پرداخت در جریان است. تا قبل از تأیید، این خرید فعال نمی‌شود.",
    approving: "تأیید واریز توسط مؤسس در حال انجام است.",
    paidActive: "این سفارش پرداخت شده و دسترسی مربوط به آن فعال است.",
    rejected: "این سفارش رد شده است. اگر هنوز همین پیشنهاد را می‌خواهید، می‌توانید سفارش تازه بسازید.",
    expired: "اعتبار پیشنهاد تمام شده؛ درخواست جدید ثبت کنید.",
    legacy: "درخواست قدیمی؛ نیازمند بررسی مجدد",
    destination: "حساب مقصد",
    referenceAccount: "حساب همین سفارش",
    holder: "به نام",
    openBot: "برای ارسال فیش، بات نورین را باز کنید.",
    sendReceipt: "ارسال رسید در بات نورین",
    createOrder: "ثبت سفارش و ارسال فیش در بات",
    preparing: "پرداخت دستی هنوز در حال آماده‌سازی است.",
    amountDue: "مبلغ قابل پرداخت",
    ordersTitle: "تاریخچه سفارش‌ها",
    older: (count) => `سفارش‌های دیگر (${count})`,
    packageKind: "پکیج یک‌باره",
    monthlyKind: "اشتراک ماهانه مستقل",
    upgradeKind: "ارتقای پکیج",
    scope: "دامنه",
    validUntil: "اعتبار پیشنهاد تا",
    credit: "اعتبار پرداخت قبلی",
    reviewAmount: "در انتظار پیشنهاد قیمت تیم نورین",
    quoteIntro: "تیم نورین دامنه را بررسی می‌کند. اشتراک ماهانه قیمت ثابت ندارد و بر اساس مقیاس، درآمد، پیچیدگی، دامنه و بار کاری پیشنهاد می‌شود.",
    awaitingTeam: "در انتظار تأیید تیم نورین. تا قبل از تأیید، پرداختی انجام نمی‌شود.",
    approvedByTeam: "دامنه و مبلغ توسط تیم نورین تأیید شده است.",
    quoteRecorded: "درخواست برای بررسی تیم نورین ثبت شد.",
    manualTitle: "پرداخت کارت‌به‌کارت",
    orderCode: "کد سفارش",
    protection: "پس از بررسی واریز واقعی توسط مؤسس، پکیج یا اشتراک فعال می‌شود. ارسال فیش به‌تنهایی تأیید پرداخت نیست.",
  },
};

export const STATUS_COPY = {
  awaiting_advisor_review: { fa: "در انتظار بررسی تیم نورین", en: "Awaiting advisor review" },
  approved_unpaid: { fa: "تأییدشده و پرداخت‌نشده", en: "Approved and unpaid" },
  awaiting_receipt: { fa: "در انتظار رسید", en: "Awaiting receipt" },
  pending_verification: { fa: "در انتظار تأیید پرداخت", en: "Pending verification" },
  approving: { fa: "در حال تأیید پرداخت", en: "Verification in progress" },
  paid: { fa: "پرداخت‌شده", en: "Paid" },
  rejected: { fa: "ردشده", en: "Rejected" },
  expired: { fa: "منقضی‌شده", en: "Expired" },
  legacy_review_required: { fa: "نیازمند بررسی مجدد", en: "New review required" },
  active: { fa: "فعال", en: "Active" },
  expiring: { fa: "نزدیک انقضا", en: "Expiring soon" },
  pending_renewal: { fa: "در انتظار تمدید", en: "Awaiting renewal" },
  none: { fa: "بدون اشتراک", en: "No subscription" },
};

export const text = (lang) => COPY[lang === "fa" ? "fa" : "en"];

export function canonicalTier(tier) {
  return tier === "Strategic" ? "Premium" : tier;
}

export function billingKind(period) {
  const value = String(period || "").toLowerCase();
  if (value === "one_time" || value === "one-time") return "one_time";
  if (value.includes("month") || value.includes("ماه")) return "monthly";
  return "";
}

export function billingLabel(period, lang) {
  const copy = text(lang);
  const kind = billingKind(period);
  if (kind === "one_time") return copy.oneTime;
  if (kind === "monthly") return copy.monthly;
  return period || copy.billingMissing;
}

function finiteAmount(amount) {
  if (typeof amount === "number") return Number.isFinite(amount) ? amount : null;
  if (typeof amount === "string" && amount.trim() && Number.isFinite(Number(amount))) return Number(amount);
  return null;
}

export function money(amount, currency, lang, tomanLabel) {
  const value = finiteAmount(amount);
  if (value === null) return "";
  const formatted = value.toLocaleString(lang === "fa" ? "fa-IR" : "en-US");
  const unit = String(currency || "").toLowerCase() === "toman" ? tomanLabel : (currency || "");
  return `${formatted}${unit ? ` ${unit}` : ""}`;
}

export function providerLabel(provider, lang) {
  const known = {
    manual_card: lang === "fa" ? "کارت‌به‌کارت" : "Bank transfer",
    stripe: "Stripe",
    paypal: "PayPal",
  };
  return known[provider] || provider || text(lang).methodMissing;
}

export function PaymentStatusLabel({ status, lang, className = "tag", testId, role }) {
  const known = STATUS_COPY[status];
  const label = known ? known[lang === "fa" ? "fa" : "en"] : (status || "");
  if (!label) return null;
  const active = status === "paid" || status === "active" || status === "expiring";
  return <span className={`${className}${active ? " tag-active" : ""}`} data-testid={testId} role={role} data-status={status || "unknown"}>{label}</span>;
}

export function ActivePlanCard({ lang, t, sub, state, ownedTier }) {
  const copy = text(lang);
  const access = state?.access_status;
  const monthly = billingKind(sub?.billing_period) === "monthly";
  const packageName = sub ? (sub.package === "Strategic" ? "Premium (Strategic)" : sub.package) : "";
  let summary = null;
  if (!sub) summary = copy.noPlanNext;
  else if (ownedTier) summary = `${copy.owned(canonicalTier(sub.package))} ${copy.packageNote}`;
  else if (access !== "expired" && monthly) summary = copy.monthlyNote;
  else if (access !== "expired" && billingKind(sub.billing_period) === "one_time") summary = copy.packageNote;
  return (
    <section className="gc-plan" data-testid="current-plan">
      <div>
        <p className="eyebrow">{copy.planEyebrow}</p>
        {sub ? <h3>{packageName}</h3> : <h3>{t.noPlan}</h3>}
        {summary && <p className="gc-plan-note" data-testid={ownedTier ? "owned-package" : undefined}>{summary}</p>}
        {sub && (
          <div className="gc-facts">
            <div className="gc-fact"><span>{copy.billing}</span><strong>{billingLabel(sub.billing_period, lang)}</strong></div>
            <div className="gc-fact"><span>{copy.amount}</span><strong>{money(sub.amount || 0, sub.currency, lang, t.toman)}</strong></div>
            <div className="gc-fact"><span>{copy.method}</span><strong>{providerLabel(sub.provider, lang)}</strong></div>
            <div className="gc-fact"><span>{copy.expiry}</span><strong data-testid="subscription-expiry">{state?.expires_at ? fmtDate(state.expires_at, lang) : copy.expiryMissing}</strong></div>
          </div>
        )}
        {access === "expired" && <p className="gc-plan-note" role="status">{lang === "fa" ? "اعتبار پایان یافته است. خدمات پولی تا تمدید غیرفعال‌اند؛ اطلاعات و تاریخچه شما محفوظ می‌ماند." : "Access has expired. Paid services require renewal; your information and history remain available."}</p>}
        {state?.status === "pending_renewal" && <p className="gc-plan-note">{lang === "fa" ? "درخواست تمدید ثبت شده است؛ اعتبار فعلی فقط پس از تأیید پرداخت تمدید می‌شود." : "Renewal requested; the current expiry changes only after payment approval."}</p>}
      </div>
      <PaymentStatusLabel status={state?.status || "none"} lang={lang} testId="subscription-status" role="status" />
    </section>
  );
}

export function PricingCard({ lang, t, proposal, selected, owned, onSelect }) {
  const copy = text(lang);
  const includes = pick(proposal.includes, lang);
  const amount = Number.isFinite(Number(proposal.price)) ? money(proposal.price, proposal.currency || "toman", lang, t.toman) : "";
  return (
    <article className={`gc-price${proposal.recommended ? " is-recommended" : ""}${selected ? " is-selected" : ""}${owned ? " is-current" : ""}`} data-testid={`proposal-${String(proposal.tier).toLowerCase()}`}>
      {proposal.recommended && <span className="gc-ribbon">{t.recommended}</span>}
      <p className="eyebrow">{canonicalTier(proposal.tier)}</p>
      <h3>{proposal.tier === "Strategic" ? (lang === "fa" ? "ویژه" : "Premium") : pick(proposal.label, lang)}</h3>
      <p className="gc-amount">{amount}<span>{billingLabel(proposal.billing_period, lang)}</span></p>
      <p className="muted">{pick(proposal.summary, lang)}</p>
      <ul>{(Array.isArray(includes) ? includes : []).map((item) => <li key={item}><Check size={14} aria-hidden="true" />{item}</li>)}</ul>
      {owned ? <p className="gc-status-line">{copy.currentPackage}</p> : (
        <button type="button" className={proposal.recommended ? "primary-button full" : "quiet-button full"} aria-pressed={selected} onClick={() => onSelect(proposal)} data-testid={`proposal-choose-${String(proposal.tier).toLowerCase()}`}>{t.choose}</button>
      )}
    </article>
  );
}

function kindLabel(kind, lang) {
  const copy = text(lang);
  return {
    package: copy.packageKind,
    monthly_subscription: copy.monthlyKind,
    upgrade: copy.upgradeKind,
  }[kind] || copy.legacy;
}


function presentCopy(value, lang) {
  if (!value || lang !== "fa") return value;
  return String(value)
    .replaceAll("تأیید مشاور انسانی", "تأیید تیم نورین")
    .replaceAll("بررسی انسانی", "بررسی تیم نورین")
    .replaceAll("مشاور انسانی", "تیم نورین");
}

export function QuoteSummary({ lang, t, quote, statusKey, order, statusNote }) {
  const copy = text(lang);
  if (!quote) return null;
  const priced = finiteAmount(quote.amount_toman);
  const amount = priced === null ? "" : money(priced, "toman", lang, t.toman);
  const note = statusNote || {
    awaiting_advisor_review: copy.awaitingTeam,
    approved_unpaid: copy.approvedByTeam,
    awaiting_receipt: copy.awaitingReceipt,
    pending_verification: copy.pending,
    approving: copy.approving,
    paid: copy.paidActive,
    rejected: copy.rejected,
    expired: copy.expired,
    legacy_review_required: copy.legacy,
  }[statusKey];
  return (
    <div className="gc-quote" data-testid="quote-summary">
      <div className="gc-quote-top">
        <div>
          <p>{kindLabel(quote.kind, lang)} · {canonicalTier(quote.tier)}</p>
          {priced === null ? <p className="gc-pending-price">{copy.reviewAmount}</p> : <strong className="gc-amount">{amount}</strong>}
        </div>
        <PaymentStatusLabel status={statusKey} lang={lang} />
      </div>
      {quote.billing_period && <p className="muted">{billingLabel(quote.billing_period, lang)}</p>}
      {quote.credit_toman > 0 && <p>{copy.credit}: {money(quote.credit_toman, "toman", lang, t.toman)}</p>}
      {quote.valid_until && <p>{copy.validUntil}: {fmtDate(quote.valid_until, lang)}</p>}
      {quote.summary && <p>{presentCopy(quote.summary, lang)}</p>}
      {Array.isArray(quote.scope) && quote.scope.length > 0 && <div><p className="muted">{copy.scope}</p><ul>{quote.scope.map((item, index) => <li key={`${item}-${index}`}>{item}</li>)}</ul></div>}
      {order?.order_id && <p>{copy.orderRegistered}: <strong dir="ltr">{order.order_id}</strong></p>}
      {note && <small>{note}</small>}
    </div>
  );
}

function formatCard(card) {
  return String(card || "").replace(/(\d{4})(?=\d)/g, "$1 ");
}

export function ManualPaymentCard({ lang, t, config, order, quote, receiptUrl, busy, canCreate, onCreate }) {
  const copy = text(lang);
  const status = order?.payment_status;
  const waiting = status === "awaiting_receipt";
  const reviewing = status === "pending_verification" || status === "approving";
  const due = finiteAmount(order?.amount) ?? finiteAmount(quote?.amount_toman);
  const heading = reviewing ? (status === "approving" ? copy.approving : copy.pending) : copy.awaitingHeading;
  return (
    <section className="gc-section gc-pay" data-testid="manual-payment">
      <div>
        <p className="eyebrow">{copy.manualTitle}</p>
        <h3>{heading}</h3>
        <p className="muted">{copy.protection}</p>
      </div>
      <div className="gc-quote">
        {order?.package && <p>{canonicalTier(order.package)} · {billingLabel(order.billing_period, lang)}</p>}
        {due !== null && <p>{copy.amountDue}: <strong>{money(due, order?.currency || quote?.currency || "toman", lang, t.toman)}</strong></p>}
        {order?.order_id && <p>{copy.orderCode}: <strong dir="ltr">{order.order_id}</strong></p>}
        {config?.ready ? (
          <div className="gc-account">
            <span>{reviewing ? copy.referenceAccount : copy.destination}</span>
            <strong dir="ltr">{formatCard(config.card_number)}</strong>
            <p>{copy.holder}: {config.account_holder}</p>
          </div>
        ) : <p className="muted">{copy.preparing}</p>}
        {waiting && <p>{receiptUrl ? copy.awaitingReceipt : copy.openBot}</p>}
        {waiting && receiptUrl && <a className="primary-button" href={receiptUrl} target="_blank" rel="noreferrer">{copy.sendReceipt}</a>}
        {reviewing && <p role="status">{status === "approving" ? copy.approving : copy.pending}</p>}
        {canCreate && config?.ready && <button type="button" className="primary-button" onClick={onCreate} disabled={Boolean(busy)}>{copy.createOrder}</button>}
      </div>
    </section>
  );
}

export function splitOrders(orders) {
  const list = Array.isArray(orders) ? orders : [];
  const primary = [];
  const older = [];
  const open = new Set(["awaiting_receipt", "pending_verification", "approving"]);
  list.forEach((order) => {
    const settledCount = primary.filter((item) => !open.has(item.payment_status)).length;
    if (open.has(order.payment_status) || (order.payment_status !== "rejected" && order.payment_status !== "expired" && settledCount < 3)) primary.push(order);
    else older.push(order);
  });
  if (!primary.length && list.length) return { primary: [list[0]], older: list.slice(1) };
  return { primary, older };
}

function OrderRow({ lang, t, order }) {
  const name = order.package === "Strategic" ? "Premium (Strategic)" : order.package;
  return (
    <div className="gc-order">
      <div>
        <strong>{name} · {money(order.amount, order.currency, lang, t.toman)}</strong>
        <small>{order.order_id && <span dir="ltr">{order.order_id}</span>}{order.order_id ? " · " : ""}{providerLabel(order.provider, lang)} · {billingLabel(order.billing_period, lang)} · {fmtDate(order.created_at, lang)}</small>
      </div>
      <PaymentStatusLabel status={order.payment_status || order.status} lang={lang} />
    </div>
  );
}

export function OrderHistory({ lang, t, orders }) {
  const copy = text(lang);
  const { primary, older } = splitOrders(orders);
  return (
    <section className="gc-section" data-testid="orders-list">
      <p className="eyebrow">{copy.ordersTitle}</p>
      {(!orders || orders.length === 0) ? <p className="muted">{t.noOrders}</p> : (
        <>
          <div className="gc-orders">{primary.map((order) => <OrderRow key={order.order_id || order.created_at} lang={lang} t={t} order={order} />)}</div>
          {older.length > 0 && (
            <details className="gc-older" data-testid="orders-older">
              <summary>{copy.older(older.length)}</summary>
              <div className="gc-orders">{older.map((order) => <OrderRow key={order.order_id || order.created_at} lang={lang} t={t} order={order} />)}</div>
            </details>
          )}
        </>
      )}
    </section>
  );
}
